module.exports = __webpack_public_path__ + "static/blurry_lobster-611555a26e1ff27864ed904876959c82.png";